import {HttpStatusCode} from 'axios';
import {saveAs} from 'file-saver';
import {format} from 'date-fns';
import {utcToZonedTime} from 'date-fns-tz';
import {Buffer} from 'buffer';
import iconv from 'iconv-lite';

import {CATEGORY_TYPE, COMPANY_TYPE, DNT_ID_TYPE, KASETU_SETUBI_TYPE,
  KENGEN_ID, OWNER, IDO_TYPE_CURRENT, KASETU_SETUBI_TYPE_FOR_IDO_TYPE,
  GIJYUTU_KENTO_KEKKA_CATEGORY_FILTER, IDO_TYPE,
  BUNKITEN_MITOROKU_TYPE,
  KASETU_SETUBI_TYPE_SELECTION} from './commonConst';
import {downloadRequest} from './backend';

/* eslint no-irregular-whitespace: ["error", {"skipRegExps": true}] */

const timeZone = 'Asia/Tokyo';
const DATE_DEFAULT = 'yyyy/MM/dd';
export const ISO_LOCAL_DATE = 'yyyy-MM-dd';
export const ISO_LOCAL_DATE_TIME = 'yyyy-MM-dd HH:mm:ss.SSS';

const harfKanaMap = {
  'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
  'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
  'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
  'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
  'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
  'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
  'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
  'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
  'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
  'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
  'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
  'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
  'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
  'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
  'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
  'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
  'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
  'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
  '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・',
};

// 全角→半角変換
export const full2Harf = (full) => {
  if (!full) return '';

  // アルファベット 数字 記号
  let harf = full.replace(/[Ａ-Ｚａ-ｚ０-９！-～]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });

  // 全角カナ→半角カナ
  const reg = new RegExp('(' + Object.values(harfKanaMap).join('|') + ')', 'g');
  const fullKanaMap = {};
  for (const item in harfKanaMap) {
    if (harfKanaMap.hasOwnProperty(item)) {
      fullKanaMap[harfKanaMap[item]] = item;
    }
  }
  harf = harf.replace(reg, function(match) {
    return fullKanaMap[match];
  })

      .replace('゛', /ﾞ/g)
      .replace('゜', /ﾟ/g)
      .replace(/　/g, ' ');

  return harf;
};

// 全角かな→半角ｶﾅ変換
export const full2Harf2 = (full) => {
  if (!full) return '';

  // 全角かな→全角カナ
  const kana = full.replace(/[\u3041-\u3096]/g, function(match) {
    const chr = match.charCodeAt(0) + 0x60;
    return String.fromCharCode(chr);
  });

  // 全角→半角変換
  const harf = full2Harf(kana);

  return harf;
};

// 半角→全角変換
export const harf2Full = (harf) => {
  if (!harf) return '';

  // アルファベット 数字 記号
  let full = harf.replace(/[A-Za-z0-9!-~]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
  });

  // 半角カナ→全角カナ
  const reg = new RegExp('(' + Object.keys(harfKanaMap).join('|') + ')', 'g');
  full = full.replace(reg, function(match) {
    return harfKanaMap[match];
  })
      .replace(/ﾞ/g, '゛')
      .replace(/ﾟ/g, '゜')
      .replace(/ /g, '　');

  return full;
};

// base64からBlob変換
export const base64toBlob = (base64, mimeCtype) => {
  const bin = window.atob(base64.replace(/^.*,/, ''));
  const buffer = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  // Blobを作成
  let blob;
  try {
    blob = new window.Blob([buffer.buffer], {
      type: mimeCtype,
    });
  } catch (e) {
    return false;
  }
  return blob;
};

// base64からBlob変換（CSV用 UTF-8 → SJIS変換）
export const base64toBlobCsv = (base64, mimeCtype) => {
  try {
    // base64デコード
    const buffer = Buffer.from(base64, 'base64').toString();

    // UTF-8からSJIS変換
    const csvData = utf8toSjis(buffer);

    // Blobを作成
    return new window.Blob([csvData], {
      type: mimeCtype,
    });
  } catch (e) {
    console.error(e);
    return false;
  }
};

// SJISからUTF-8変換
export const sjisToUtf8 = (str) => {
  try {
    // 文字コード変換(SJIS → UTF-8)
    const data = iconv.decode(str, 'shift-jis');
    return data.replace(/\r\n/g, '\n');
  } catch (e) {
    console.error(e);
    return false;
  }
};

// UTF-8からSJIS変換
export const utf8toSjis = (str) => {
  try {
    // 改行コード変換(\n → \r\n)
    const dataCrlf = str.replace(/\r\n/g, '\n').replace(/\n/g, '\r\n');
    // 文字コード変換(UTF-8 → SJIS)
    const dataSjis = iconv.encode(dataCrlf, 'Shift_JIS');
    return dataSjis;
  } catch (e) {
    console.error(e);
    return false;
  }
};

/**
 * スマートフォン判定
 * @return {boolean} iOS/Androidの場合true、それ以外の場合false
 */
export const isSmartPhone = () => {
  return navigator.userAgent.match(/iPhone|iPad|Android/);
};

/**
 * NULLチェック
 * @param {object} obj
 * @return {boolean} true:null
 */
export const isNull = (obj) => {
  return obj === undefined || obj === null;
};

/**
 * 空文字判定
 * @param {object} obj オブジェクト
 * @return {boolean} true:空, false:空以外
 */
export const isEmptyString = (obj) => {
  return (isNull(obj) || obj.length === 0);
};

/**
 * オブジェクトの空判定
 * @param {object} obj オブジェクト
 * @return {boolean} true:空, false:空以外
 */
export const isEmptyObject = (obj) => {
  return (isNull(obj) || Object.keys(obj).length === 0);
};

/**
 * 帳票(PDF)の作成
 *
 * @param {object} props
 * @param {string} id
 * @param {object} param
 * @param {string} fileName
 * @return {Promise<boolean>} 成功時はtrue、失敗時はfalse
 */
export async function createTyohyoPdf(props, id, param = {}, fileName = '') {
  return await createTyohyo(props, id, param, fileName);
}

/**
 * 帳票の作成 共通部分
 *
 * @param {object} props
 * @param {string} id
 * @param {object} body
 * @param {string} fileName
 * @return {Promise<boolean>} 成功時はtrue、失敗時はfalse
 */
export async function createTyohyo(props, id, body, fileName) {
  try {
    const response = await downloadRequest('v1.0/' + id.toLowerCase(), body);
    if (response.status === HttpStatusCode.GatewayTimeout) {
      // 帳票作成に時間がかかってタイムアウトした場合
      props.doShowMessage({
        message: 'BFY000330E',
        highPriority: true,
      });
    } else if (response.status !== HttpStatusCode.Ok) {
      if (response.data) {
        props.doShowMessage({
          message: {id: response.data.message.id,
            text: response.data.message.text},
        });
      }
    } else {
      const outputName = fileName || decodeURI(response.headers['content-disposition'].split('filename*=')[1].split(';')[0]).replace(/"/g, '');
      saveAs(response.data, outputName);
      // ダウンロードURL取得APIのエラーがある場合、ダイアログ表示
      if (response.apiErrorMessage) {
        props.doShowMessage({
          message: {id: response.apiErrorMessage.id,
            text: response.apiErrorMessage.text},
        });
      }
    }
    return true;
  } catch (err) {
    return false;
  }
}

/**
 * 日付型（UTC）のフォーマット変換
 *
 * @param {string} date 文字列
 * @param {string} [changeFormat] 出力フォーマット
 * @return {string}} 変換した日付
 */
export function formatUtcDate(date, changeFormat = DATE_DEFAULT) {
  if (!date) {
    return '';
  }
  const zonedDate = utcToZonedTime(new Date(date), timeZone);
  return changeDateFormatter(zonedDate, changeFormat);
}

/**
 * 日付型のフォーマット変換
 *  @param {string} date
 * @param {string} changeFormat
 * @return {string} 変換後の日付データ
 */
export function formatStringDate(date, changeFormat = DATE_DEFAULT) {
  if (!date) {
    return '';
  }
  return changeDateFormatter(new Date(date), changeFormat);
}

/**
 * 日付型のフォーマット変換
 *  @param {number|Object} date
 * @param {string} changeFormat
 * @return {string} 変換後の日付データ
 */
export function formatDate(date, changeFormat = DATE_DEFAULT) {
  return changeDateFormatter(date, changeFormat);
}

/**
 * 日付型のフォーマット変換
 * @param {number|Object} date
 * @param {string} changeFormat
 * @return {string} 変換後の日付データ
 */
export function changeDateFormatter(date, changeFormat) {
  return format(date, changeFormat);
}

/**
 * 文字列から費用のフォーマット変換
 * @param {string} value
 * @return {string} 変換後のデータ
 */
export function formatStringToPrice(value) {
  if (value === null || value === undefined || value === '') {
    return value;
  }
  value = Math.floor(parseFloat(value));
  let formattedValue = value.toLocaleString('ja-JP');
  formattedValue += '円';
  return formattedValue;
}

/**
 * 汎用マスタを用いたコード→名称変換用MAP生成
 *
 * @param {object} genericMap 全汎用マスタ
 * @param {string[]} categories 使用する区分一覧
 * @return {object} 変換用MAP
 */
export function createGenericNameMap(genericMap, categories) {
  const genericNameMap = {};

  for (const category of categories) {
    const itemMap = {};
    genericNameMap[category] = itemMap;

    for (const item of genericMap[category]) {
      itemMap[item.cd] = item.cdName;
    }
  }

  return genericNameMap;
}

/**
 * 数値を3桁カンマ区切りにする
 * @param {number} num 数値
 * @return {string} 3桁カンマ区切りにした文字列
 */
export function convertCommaSeparated(num) {
  return num ? num.toLocaleString('ja-JP') : num;
}

/**
 * 汎用マスタからコンボボックス表示用リストを取得する
 * @param {object} generalPurposeMap 汎用マスタデータ
 * @param {string} kbn 汎用マスタの区分種別
 * @param {bool} emptyHeader true:表示リストの先頭行に空白あり, false:先頭行に空白なし
 * @param {object} options 除外条件 {key: [value, ...]}
 * @return {array} コンボボックス表示用リスト [{label: 表示名称, value:コード値}]
 */
export function getComboList(
    generalPurposeMap, kbn, emptyHeader=true, options={}) {
  let resultList = [{label: '', value: ''}];
  if (!generalPurposeMap ||
    !Object.hasOwnProperty.call(generalPurposeMap, kbn)) {
    return resultList;
  }

  if (!emptyHeader) {
    resultList = [];
  }

  for (const data of generalPurposeMap[kbn]) {
    if (Object.keys(options).length > 0) {
      let skip = false;
      for (const key of Object.keys(options)) {
        if (!options[key]) {
          continue;
        }
        let _array = [];
        if (Array.isArray(options[key])) {
          _array = options[key];
        } else {
          _array.push(options[key]);
        }
        skip = Object.hasOwnProperty.call(data, key) &&
          (_array.includes(data[key]));
      }
      if (skip) {
        continue;
      }
    }
    resultList.push({label: data.cdName, value: data.cd});
  }

  return resultList;
}

/**
 * コード値をキーにしてコンボボックス表示用リストから表示名称を取得する
 * @param {object} genericMst 汎用マスタデータ
 * @param {string} kbn 汎用マスタの区分種別
 * @param {string} code コード値
 * @return {array} コード値に対応する表示名称
 */
export function getComboName(genericMst, kbn, code) {
  const list = getComboList(genericMst, kbn);
  const obj = list ? list.filter(
      (data)=>data.value == code) : [];
  return obj && obj.length > 0 ? obj[0].label : '';
}

/**
 * 事業場の選択リストを取得する
 * @param {array} zigyojyoList 電柱マスタの事業場リスト
 * @param {string} labelKey 選択リストの表示名を設定する
 * @param {string} valueKey 選択リストの値を設定する
 * @param {string} emptyHeader true:表示リストの先頭行に空白あり, false:先頭行に空白なし
 * @return {array} 事業場の選択リスト
 */
export function getZigyojoSelectList(zigyojyoList, labelKey='cdName', valueKey='cd', emptyHeader=true) {
  let list = [{[labelKey]: '', [valueKey]: ''}];
  if (zigyojyoList === undefined || zigyojyoList === null) {
    return list;
  }

  if (!emptyHeader) {
    list = [];
  }

  for (const data of zigyojyoList) {
    list.push({[labelKey]: data.zigyojoName, [valueKey]: data.zigyojoCd});
  }

  return list;
}

/**
   * 条件に一致するデータのindexを返す
   * @param {array} list
   * @param {func} callback
   * @return {number} インデックス
   */
export function findIndex(list, callback) {
  if (!list || !callback) {
    return -1;
  }
  return list.findIndex(callback);
};

/**
 * 汎用マスタから区分に対応するコード一覧を取得する
 * @param {object} genericMap
 * @param {string} categoryType
 * @return {array} コード一覧
 */
export function searchMap(genericMap, categoryType) {
  return genericMap && (categoryType in genericMap) ?
    genericMap[categoryType] : [];
}

/**
 * @typedef Filter コンボ絞り込みオプション
 * @property {array} setubiType 架設設備種別
 * @property {string} companyType 会社（NTT,NTT以外)
 */
/**
 * コンボデータ取得パラメータ
 * @property {string} キー 画面項目のバインディング、またはユーザが定義したキー
 * @property {string} categoryType 汎用マスタの区分
 * @property {Filter} filters コンボ絞り込みオプション
 */
const dataMapping = {
  'kasetuBunrui': {categoryType: CATEGORY_TYPE.KASETU_BUNRUI},
  'keikanType': {categoryType: CATEGORY_TYPE.KEIKAN_TYPE},
  'senyuSize': {categoryType: CATEGORY_TYPE.SENYU_SIZE},
  'kojibasyoZigyojo': {categoryType: CATEGORY_TYPE.ZIGYOJO},
  'kojibasyoPrefectures': {categoryType: CATEGORY_TYPE.PREFECTURES},
  'kojibasyoMunicipalities': {categoryType: CATEGORY_TYPE.MUNICIPALITIES},
  'kojibasyoOazatusyo': {categoryType: CATEGORY_TYPE.OAZATUSYO},
  'kojibasyoAzatyome': {categoryType: CATEGORY_TYPE.AZATYOME},
  'orderStatus': {categoryType: CATEGORY_TYPE.ORDERSTATUS},
  'orderStatusNtt': {categoryType: CATEGORY_TYPE.ORDERSTATUS_NTT},
  'kyogatyuTorokuStatus': {categoryType: CATEGORY_TYPE.KYOGATYU_TOROKU_STATUS},
  'issokukaCategory': {categoryType: CATEGORY_TYPE.ISSOKUKA},
  'issokukaCurrent': {categoryType: CATEGORY_TYPE.ISSOKUKA},
  'positionLink': {categoryType: CATEGORY_TYPE.POSITION_LINK},
  'positionLink1': {categoryType: CATEGORY_TYPE.POSITION_LINK},
  'positionLink2': {categoryType: CATEGORY_TYPE.POSITION_LINK},
  'idoType': {categoryType: CATEGORY_TYPE.IDO_TYPE},
  'idoType_current': {categoryType: CATEGORY_TYPE.IDO_TYPE, filters: {valueString1: [IDO_TYPE_CURRENT]}},
  'idoType_tusin': {categoryType: CATEGORY_TYPE.IDO_TYPE, filters: {valueString2: [KASETU_SETUBI_TYPE_FOR_IDO_TYPE.ALL, KASETU_SETUBI_TYPE_FOR_IDO_TYPE.TUSHIN]}},
  'idoType_kiki': {categoryType: CATEGORY_TYPE.IDO_TYPE, filters: {valueString2: [KASETU_SETUBI_TYPE_FOR_IDO_TYPE.ALL, KASETU_SETUBI_TYPE_FOR_IDO_TYPE.KIKI]}},
  'kasetuSetubiBunrui': {categoryType: CATEGORY_TYPE.KASETU_SETUBI_BUNRUI},
  'kasetuSetubiType': {categoryType: CATEGORY_TYPE.KASETU_SETUBI_TYPE},
  'kasetuSetubiCd': {categoryType: CATEGORY_TYPE.KASETU_SETUBI_CD},
  'kasetuSetubiCdNtt': {categoryType: CATEGORY_TYPE.KASETU_SETUBI_CD_NTT},
  'suiheiTyokakuZahyokei': {categoryType: CATEGORY_TYPE.SUIHEI_TYOKAKU_ZAHYOKEI},
  'kasetuSetubiTushin': {categoryType: CATEGORY_TYPE.KASETU_SETUBI_CD, filters: {valueNum1: [KASETU_SETUBI_TYPE.TUSHIN]}},
  'kasetuSetubiKikiGairoto': {categoryType: CATEGORY_TYPE.KASETU_SETUBI_CD, filters: {valueNum1: [KASETU_SETUBI_TYPE.KIKI]}},
  'kasetuSetubiCdNttTushin': {categoryType: CATEGORY_TYPE.KASETU_SETUBI_CD_NTT, filters: {valueNum1: [KASETU_SETUBI_TYPE.TUSHIN]}},
  'kasetuSetubiCdNttKikiGairoto': {categoryType: CATEGORY_TYPE.KASETU_SETUBI_CD_NTT, filters: {valueNum1: [KASETU_SETUBI_TYPE.KIKI]}},
  'senkaJyokyo': {categoryType: CATEGORY_TYPE.SENKA_JYOKYO},
  'toritukeWay': {categoryType: CATEGORY_TYPE.TORITUKE_WAY},
  'orgToritukeWay': {categoryType: CATEGORY_TYPE.TORITUKE_WAY},
  'toritukeHoi': {categoryType: CATEGORY_TYPE.TORITUKE_HOI},
  'orgToritukeHoi': {categoryType: CATEGORY_TYPE.TORITUKE_HOI},
  'toritukeType': {categoryType: CATEGORY_TYPE.TORITUKE_TYPE},
  'orgToritukeType': {categoryType: CATEGORY_TYPE.TORITUKE_TYPE},
  'saisekkinHaidenSetubi': {categoryType: CATEGORY_TYPE.SAISEKKIN_HAIDEN_SETUBI},
  'saisekkinHaidenSetubiKiki': {categoryType: CATEGORY_TYPE.SAISEKKIN_HAIDEN_SETUBI, andFilters: {valueString1: [COMPANY_TYPE.OTHER, COMPANY_TYPE.ALL], valueString2: [KASETU_SETUBI_TYPE_SELECTION.ALL]}},
  'saisekkinHaidenSetubiTushin': {categoryType: CATEGORY_TYPE.SAISEKKIN_HAIDEN_SETUBI, andFilters: {valueString1: [COMPANY_TYPE.OTHER, COMPANY_TYPE.ALL], valueString2: [KASETU_SETUBI_TYPE_SELECTION.TUSHIN, KASETU_SETUBI_TYPE_SELECTION.ALL]}},
  'saisekkinHaidenSetubiNtt': {categoryType: CATEGORY_TYPE.SAISEKKIN_HAIDEN_SETUBI, filters: {valueString1: [COMPANY_TYPE.NTT, COMPANY_TYPE.ALL]}},
  'yaridasiSiyoUmu': {categoryType: CATEGORY_TYPE.UMU_CATEGORY},
  'sousaHimoIsetuYohi': {categoryType: CATEGORY_TYPE.SOUSA_HIMO_ISETU_YOHI},
  'kaisyuKojiIraiNaiyo': {categoryType: CATEGORY_TYPE.KAISYU_KOJI_IRAI_NAIYO},
  'gijyutuKentoYohi': {categoryType: CATEGORY_TYPE.YOUHI_CATEGORY},
  'yotiUmu': {categoryType: CATEGORY_TYPE.UMU_CATEGORY},
  'sisenKyoyo': {categoryType: CATEGORY_TYPE.UMU_CATEGORY},
  'gijyutuKentoKekka': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_CATEGORY},
  'gijyutuKentoKekkaCommon': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_CATEGORY, filters: {valueString1: [GIJYUTU_KENTO_KEKKA_CATEGORY_FILTER.COMMON]}},
  'gijyutuKentoKekkaKajyoken': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_KAJOKEN_CATEGORY},
  'gijyutuKentoKekkaFukariyu': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_FUKARIYU},
  'gijyutuKentoKekkaGenbaRiyu': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_GENBARIYU},
  'gijyutuKentoKekkaGenba': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_CATEGORY},
  'gijyutuKentoKekkaGenbaKajyoken': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_KAJOKEN_CATEGORY},
  'gijyutuKentoKekkaGenbaFukariyu': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_FUKARIYU},
  'kaisyuSekkeiHaidenYohi': {categoryType: CATEGORY_TYPE.YOUHI_CATEGORY_HAIDEN_KAISYU},
  'kaisyuSekkeiTusinYohi': {categoryType: CATEGORY_TYPE.YOUHI_CATEGORY},
  'isetuJissiCategory': {categoryType: CATEGORY_TYPE.HIMO_IAETU_JISSI_CATEGORY},
  'dentuKaifuriyu': {categoryType: CATEGORY_TYPE.TUSIN_KAIHU_RIYU},
  'kaisyuKojiNaiyoHaiden': {categoryType: CATEGORY_TYPE.KAISYU_KOJI_NAIYO_HAIDEN},
  'kaisyuKojiNaiyoTusin': {categoryType: CATEGORY_TYPE.KAISYU_KOJI_NAIYO_TUSIN},
  'type': {categoryType: CATEGORY_TYPE.BUNKITEN_MITOROKU_TYPE},
  'dempyoCategory': {categoryType: CATEGORY_TYPE.DEMPYO_CATEGORY},
  'orderTorikesiCategory': {categoryType: CATEGORY_TYPE.ORDER_KAIJYO_CATEGORY},
  'addressPrefectures': {categoryType: CATEGORY_TYPE.PREFECTURES},
  'addressMunicipalities': {categoryType: CATEGORY_TYPE.MUNICIPALITIES},
  'addressAzatyome': {categoryType: CATEGORY_TYPE.AZATYOME},
  'userLevel': {categoryType: CATEGORY_TYPE.USER_LEVEL},
  'kyogaBukkenKindCd': {categoryType: CATEGORY_TYPE.KYOGA_BUKKEN_SYURUI_CD},
  'kyogabasyoZigyojo': {categoryType: CATEGORY_TYPE.ZIGYOJO},
  'kyogabasyoPrefectures': {categoryType: CATEGORY_TYPE.PREFECTURES},
  'kyogabasyoMunicipalities': {categoryType: CATEGORY_TYPE.MUNICIPALITIES},
  'linkUmu': {categoryType: CATEGORY_TYPE.UMU_CATEGORY},
  'gijyutuKentoSummaryKekka': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_CATEGORY},
  'gijyutuKentoSummaryKajyoken': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_KAJOKEN_CATEGORY},
  'gijyutuKentoSummaryFukariyu': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_FUKARIYU},
  'gijyutuKentoSummaryGenbaRiyu': {categoryType: CATEGORY_TYPE.GIJYUTU_KENTO_KEKKA_GENBARIYU},
  'categoryType': {categoryType: CATEGORY_TYPE.CATEGORY_TYPE},
  'sisetuKakuninKekka': {categoryType: CATEGORY_TYPE.TEKI_FUTEKI_CATEGORY},
  'futekiCategory': {categoryType: CATEGORY_TYPE.FUTEKI_CATEGORY},
  'owner': {categoryType: CATEGORY_TYPE.OWNER},
  'ownerNotHaiden': {categoryType: CATEGORY_TYPE.OWNER, filters: {valueNum1: [OWNER.CHUDEN_TUSHIN, OWNER.NTT, OWNER.KANKOTYO, OWNER.SONOTA]}},
  'dntCategory': {categoryType: CATEGORY_TYPE.DNT_CATEGORY},
  'dntCategory1': {categoryType: CATEGORY_TYPE.DNT_CATEGORY},
  'dntCategory2': {categoryType: CATEGORY_TYPE.DNT_CATEGORY},
  'nttDntCategory': {categoryType: CATEGORY_TYPE.NTT_DNT_CATEGORY},
  'nttDntCategory1': {categoryType: CATEGORY_TYPE.NTT_DNT_CATEGORY},
  'nttDntCategory2': {categoryType: CATEGORY_TYPE.NTT_DNT_CATEGORY},
  'zigyojoCd': {categoryType: CATEGORY_TYPE.ZIGYOJO},
  'zigyojo1Cd': {categoryType: CATEGORY_TYPE.ZIGYOJO},
  'zigyojo2Cd': {categoryType: CATEGORY_TYPE.ZIGYOJO},
  'callenderType': {categoryType: CATEGORY_TYPE.CALLENDER_TYPE},
  'kyogaKaisyuKahi': {categoryType: CATEGORY_TYPE.KAHI_CATEGORY},
  'kyogaKaisyuNaiyo': {categoryType: CATEGORY_TYPE.KYOGASYA_KAISYU_KOJI_NAIYO},
  'companyCd': {categoryType: CATEGORY_TYPE.COMPANY_CD},
  'zigyojoCategory': {categoryType: CATEGORY_TYPE.ZIGYOJO_CATEGORY},
  'zigyojoLevel': {categoryType: CATEGORY_TYPE.ZIGYOJO_LEVEL},
  'yakuwariRoleId': {categoryType: CATEGORY_TYPE.YAKUWARI_ROLE_ID},
  'tosyaKaisyuIraiKahi': {categoryType: CATEGORY_TYPE.KAHI_CATEGORY},
  'jyuyodo': {categoryType: CATEGORY_TYPE.JYUYODO},
  'limit': {categoryType: CATEGORY_TYPE.LIMIT},
  'yakkanStatus': {categoryType: CATEGORY_TYPE.YAKKAN_STATUS},
  'umuCategory': {categoryType: CATEGORY_TYPE.UMU_CATEGORY},
  'sekkeiUmuJyokenCategory': {categoryType: CATEGORY_TYPE.SEKKEI_UMU_JYOKEN_CATEGORY},
  'sekkeiUmuCategory': {categoryType: CATEGORY_TYPE.SEKKEI_UMU_CATEGORY},
  'kisetuUmuCategory': {categoryType: CATEGORY_TYPE.KISETU_UMU_CATEGORY},
  'renrakuNaiyo': {categoryType: CATEGORY_TYPE.MESSAGE_RENRAKU_NAIYO},
  'kyogaCategory': {categoryType: CATEGORY_TYPE.KYOGA_CATEGORY},
  'sousaHimoKoteiHoho': {categoryType: CATEGORY_TYPE.SOUSAHIMO_KOTEIHOHO},
  'jyuyojikoRenrakuType': {categoryType: CATEGORY_TYPE.JYUYOJIKO_RENRAKU_CATEGORY},
  'henkoRenrakuKojiKind': {categoryType: CATEGORY_TYPE.HENKO_RENRAKU_KOJI_KIND},
  'kyogatyuHenkoKojiNaiyo': {categoryType: CATEGORY_TYPE.KYOGATYU_HENKO_KOJI_NAIYO},
  'sijibutuKind': {categoryType: CATEGORY_TYPE.SIJIBUTU_KIND},
  'idoSn': {categoryType: CATEGORY_TYPE.IDO_SN},
  'idoEw': {categoryType: CATEGORY_TYPE.IDO_EW},
  'henkoRenrakuTutiHoho': {categoryType: CATEGORY_TYPE.HENKO_RENRAKU_TUTI_HOHO},
  'kyogatyuHenkoIsetuKojiNaiyo': {categoryType: CATEGORY_TYPE.KYOGATYU_HENKO_ISETU_KOJI_NAIYO},
  'henkoRenrakuTaisyo': {categoryType: CATEGORY_TYPE.HENKO_RENRAKU_TAISYO},
  'dntOwner': {categoryType: CATEGORY_TYPE.OWNER},
  'genericMst': {categoryType: CATEGORY_TYPE.GENERIC_MST},
  'gijyutuKentoGenbaYohi': {categoryType: CATEGORY_TYPE.YOUHI_CATEGORY},
  'kaisyuKojiBaseHaidenSekkei': {categoryType: CATEGORY_TYPE.KAISYU_KOJI_BASE_HAIDEN},
  'kaisyuKojiKasanHaidenSekkei': {categoryType: CATEGORY_TYPE.KAISYU_KOJI_KASAN_HAIDEN},
  'kaisyuKojiBaseTusinSekkei': {categoryType: CATEGORY_TYPE.KAISYU_KOJI_BASE_TUSIN},
  'kaisyuKojiBaseHaidenJisseki': {categoryType: CATEGORY_TYPE.KAISYU_KOJI_BASE_HAIDEN},
  'kaisyuKojiKasanHaidenJisseki': {categoryType: CATEGORY_TYPE.KAISYU_KOJI_KASAN_HAIDEN},
  'kaisyuKojiBaseTusinJisseki': {categoryType: CATEGORY_TYPE.KAISYU_KOJI_BASE_TUSIN},
  'nttEigyosyo': {categoryType: CATEGORY_TYPE.NTT_EIGYOSYO},
  'nttEigyosyo1': {categoryType: CATEGORY_TYPE.NTT_EIGYOSYO},
  'nttEigyosyo2': {categoryType: CATEGORY_TYPE.NTT_EIGYOSYO},
  'kyogaKaisyuHiRiyu': {categoryType: CATEGORY_TYPE.TOSYA_KAISYU_IRAI_HI_RIYU},
  'sisetuKakuninTantokasyo': {categoryType: CATEGORY_TYPE.KYOGA_TANTOKASYO},
  'sisetuKakuninTantozigyojo': {categoryType: CATEGORY_TYPE.ZIGYOJO},
  'orgIssokukaCategory': {categoryType: CATEGORY_TYPE.ISSOKUKA},
  'sekkeiCategory': {categoryType: CATEGORY_TYPE.SEKKEI_CATEGORY},
  'sasimodosiCategory': {categoryType: CATEGORY_TYPE.SASIMODOSI_CATEGORY},
  'tosyaKaisyuIraiHiRiyu': {categoryType: CATEGORY_TYPE.TOSYA_KAISYU_IRAI_HI_RIYU},
  'bunkitenType': {categoryType: CATEGORY_TYPE.BUNKITEN_MITOROKU_TYPE},
  'sofusakiPrefectures': {categoryType: CATEGORY_TYPE.PREFECTURES},
  'seikyuTaisyoKikan': {categoryType: CATEGORY_TYPE.SEIKYU_TAISYO_KIKAN},
  'siharaiHohoCategory': {categoryType: CATEGORY_TYPE.SIHARAI_HOHO_CATEGORY},
  'seikyusyoCreateCategory': {categoryType: CATEGORY_TYPE.SEIKYUSYO_CREATE_CATEGORY},
  'kozaType': {categoryType: CATEGORY_TYPE.KOZA_TYPE},
  'settiKoho': {categoryType: CATEGORY_TYPE.SETTI_KOHO},
  'timoku': {categoryType: CATEGORY_TYPE.TIMOKU},
  'kantyoCd': {categoryType: CATEGORY_TYPE.KANTYO_CD},
  'doroCd': {categoryType: CATEGORY_TYPE.DORO_CD},
  'kanMinCategory': {categoryType: CATEGORY_TYPE.KAN_MIN_CATEGORY},
  'tankasaZogenCategory': {categoryType: CATEGORY_TYPE.ZOGEN_CATEGORY},
  'seikyuYohiHenko': {categoryType: CATEGORY_TYPE.SEIKYU_YOHI_HENKO},
};

/**
 * 汎用マスタからコード一覧（絞り込み）を取得する
 * @param {object} genericMap 汎用マスタ
 * @param {string} key バインドキー
 * @param {Array} filterValues 対象とする値の一覧 絞り込みなしの場合指定しない
 * @return {array} コード一覧
 */
export function getFilteringMap(genericMap, key, filterValues) {
  if (!key) { // key未指定時は絞り込まない
    return genericMap;
  }
  const mapping = (
    !dataMapping[key] ? {categoryType: key} :
    dataMapping[key]);
  const category = mapping.categoryType;
  const filters = mapping.filters;
  const andFilters = mapping.andFilters;
  let items = genericMap[category];
  if (!items) {
    return [];
  }

  if (filters) {
    // filtersの定義内容 {汎用マスタのカラム: [対象値の配列]}
    // filtersに定義した内容のいずれかの条件に一致した場合、選択値に含める
    items = items.filter((data) => {
      let result = false;
      for (const filterKey of Object.keys(filters)) {
        if (filters[filterKey].includes(data[filterKey])) {
          result = true;
          break;
        }
      }
      return result;
    });
  } else if (andFilters) {
    // andFiltersの定義内容 {汎用マスタのカラム: [対象値の配列]}
    // andFiltersに定義した内容のすべての条件に一致した場合、選択値に含める
    items = items.filter((data) => {
      let result = true;
      for (const filterKey of Object.keys(andFilters)) {
        if (!andFilters[filterKey].includes(data[filterKey])) {
          result = false;
          break;
        }
      }
      return result;
    });
  }
  if (filterValues) {
    items = items.filter((data) => {
      return filterValues.includes(data.cd);
    });
  }
  return items;
}

/**
 * リストを汎用的な形式に変換
 * @param {*} list 対象のリスト
 * @param {*} listValue 対象の値に利用するカラム名
 * @param {*} listLabel 対象のラベルに利用するカラム名
 * @return {*}
 */
export function convertListToGeneric(list,
    listValue = 'zigyojoCd', listLabel = 'zigyojoName') {
  let result = [];
  for (const obj of list) {
    result.push({cd: obj[listValue], cdName: obj[listLabel]});
  }
  return result;
}

/**
 * メッセージに埋め込むラベル名を作成
 * @param {string} groupName グループ名
 * @param {string} headerName ヘッダー名
 * @return {string} メッセージに埋め込むラベル名
 */
export function createMessageLabel(groupName, headerName) {
  return groupName ? groupName + '/' + headerName : headerName;
}

/**
 * 年月を年月日に変換する
 * @param {object} data データ
 * @param {string} key キー
 */
export function convertMonthToDate(data, key) {
  if (Object.hasOwn(data, key) && data[key]) {
    data[key] = data[key] + '-01';
  }
}

/**
   * 基準電柱の緯度経度から到着点の緯度経度を計算する
   * @param {number} idBase 基準電柱の緯度
   * @param {number} keidoBase 基準電柱の経度
   * @param {number} hoikaku 方位
   * @param {number} kyori 距離(m)
   * @return {object} 到着点の緯度経度
   */
export function calculateArrivalPoint(idBase, keidoBase, hoikaku, kyori) {
  if (idBase === undefined || idBase === null ||
      keidoBase === undefined || keidoBase === null ||
      hoikaku === undefined || hoikaku === null ||
      kyori === undefined || kyori === null) {
    return {ido: null, keido: null};
  }

  // 地球の半径(m)(GRS80)
  const EARTH_RADIUS = 6378137;

  // 出発点の緯度経度をラジアンに変換
  const rad = Math.PI / 180;
  const idoRad = idBase * rad;
  const keidoRad = keidoBase * rad;

  // 距離を地球の半径でわる
  const kyoriRad = kyori / EARTH_RADIUS;

  // 到着点の緯度を計算
  const idoTmp = Math.sin(idoRad) * Math.cos(kyoriRad) +
              Math.cos(idoRad) * Math.sin(kyoriRad) * Math.cos(hoikaku * rad);
  const arrivalIdoRad = Math.asin(idoTmp);
  const arrivalIdo = arrivalIdoRad * (180 / Math.PI);

  // 到着点の経度を計算
  const y = Math.sin(hoikaku*rad) * Math.sin(kyoriRad) * Math.cos(idoRad);
  const x = Math.cos(kyoriRad) - Math.sin(idoRad) * Math.sin(arrivalIdoRad);
  const arrivalKeidoRad = keidoRad + Math.atan2(y, x);
  const arrivalKeido = arrivalKeidoRad * (180 / Math.PI);

  const retIdo = parseFloat(arrivalIdo.toFixed(6));
  const retKeido = parseFloat(arrivalKeido.toFixed(6));
  return {ido: retIdo, keido: retKeido};
}

/**
 * 文字列の頭文字を大文字にする
 * @param {string} str
 * @return {string} 変換文字列
 */
export function capitalizeFirstLetter(str) {
  if (!str) {
    return str;
  }
  return str.substring(0, 1).toUpperCase() + str.substring(1);
}

/**
 * 行番号を埋込文字列に変換する
 * @param {*} rowIndex
 * @return {string} メッセージに埋め込む行番号
 */
export function formatRowIndex(rowIndex) {
  return rowIndex === '' || rowIndex === ' ' ? rowIndex : '(' + rowIndex + '行目)';
}

/**
 * 選択した電柱の選択入力対象種別をチェックして電柱ID種別を返す
 *  電柱ID種別 = null（電柱マスタ）        : dnt.infoType == A
 *  電柱ID種別 = 1（共架物件マスタ（設備））: dnt.infoType == B かつ isBunkiMitoroku == false
 *  電柱ID種別 = 2（共架物件マスタ（分岐点・未登録電柱））: dnt.infoType == B かつ isBunkiMitoroku == true
 *  電柱ID種別 = 3（設備（電柱））         : dnt.infoType == D かつ isBunkiMitoroku == false
 *  電柱ID種別 = 4（分岐点）               : dnt.infoType == D かつ isBunkiMitoroku == true
 *  電柱ID種別 = 5（未登録電柱）           : dnt.infoType == C
 *  電柱ID種別 = 9（その他）               : 引込柱、支持点
 * @param {object} dnt 電柱選択の戻り値
 * @return {string} 電柱ID種別
 */
export function getDntIdType(dnt) {
  let dntIdType = null;
  if (dnt.infoType === 'A') {
    dntIdType = null;
  } else if (dnt.infoType === 'B') {
    dntIdType = dnt.isBunkiMitoroku ?
      DNT_ID_TYPE.BUKKEN_BUNKI : DNT_ID_TYPE.BUKKEN_SETUBI;
  } else if (dnt.infoType === 'C') {
    dntIdType = DNT_ID_TYPE.MITOUROKU;
  } else if (dnt.infoType === 'D') {
    dntIdType = dnt.isBunkiMitoroku ?
      dnt.type === BUNKITEN_MITOROKU_TYPE.BUNKI ?
        DNT_ID_TYPE.BUNKI :
        dnt.type === BUNKITEN_MITOROKU_TYPE.MITOUROKU ?
          DNT_ID_TYPE.MITOUROKU :
          DNT_ID_TYPE.OTHER :
      DNT_ID_TYPE.SETUBI;
  } else {
    // do nothing
  }

  return dntIdType;
}

export function getIdoType(dnt) {
  let result = null;
  if (dnt.infoType == 'B') {
    // 共架物件マスタを選択した場合
    result = IDO_TYPE.HAISHI;
  } else if (dnt.infoType == 'A') {
    // 電柱マスタを選択した場合
    result = IDO_TYPE.SHINSETU;
  } else {
    // do nothing
  }
  return result;
}

/**
 * ユーザーの契約が一般共架か判定する
 * @param {string} roleId ログインユーザーの権限ID
 * @return {*} true: 一般共架、false:街路灯
 */
export function isIppanKeiyaku(roleId='') {
  return roleId !== KENGEN_ID.GAIROTO;
};

/**
 * 画面を別タブ表示
 * @param {string} path 遷移先画面
 */
export function openAnotherWindow(path) {
  window.open(path, '_blank');
};

/**
 * 値が整数かどうか判定する
 * @param {*} value 値
 * @return {boolean} true:整数, false:整数以外
 */
export function isIntValue(value) {
  return /^[+,-]?\d+$/.test(value);
}

/**
 * 値が整数、少数かどうか判定する
 * @param {*} value 値
 * @return {boolean} true:整数または少数, false:整数、少数以外
 */
export function isFloatValue(value) {
  return /^[+,-]?\d+(\.\d+)?$/.test(value);
}

/**
 * 値が6桁の英字（大文字）かどうか判定する
 * @param {*} value 値
 * @return {boolean} true:6桁の英字（大文字）, false:6桁の英字（大文字）以外
 */
export function isSixString(value) {
  if (value === undefined || value === null) {
    return false;
  }
  return /^[A-Z]{6}$/.test(value);
}
